import type React from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import LoaderGradient from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Loader/LoaderGradient";
import { proNavigator } from "single-spa/react-app/ProNavigator";

type Props = {
    stateId: string;
    linkText?: string;
    isLoading?: boolean;
    onClick?: () => void;
};

const CardFooter: React.FC<Props> = ({ stateId, linkText, isLoading, onClick }) => {
    const textKey = linkText || "si.company-analysis.card.full_report";
    return (
        <Flex
            alignItems="center"
            justifyContent="flex-end"
            padding="0 8px"
            borderTop={`1px solid ${colorsPalettes.carbon["100"]}`}
            borderRadius="0 0 6px 6px"
            height="52px"
        >
            {isLoading ? (
                <LoaderGradient
                    width={91}
                    height={36}
                />
            ) : (
                <Button
                    type="flat"
                    onClick={() => {
                        void proNavigator.go(stateId);
                        onClick?.();
                    }}
                >
                    {translate(textKey)}
                </Button>
            )}
        </Flex>
    );
};

export default CardFooter;
